export default "__VITE_ASSET__a5fw6jML__"